<mat-toolbar color="primary" class="header-toolbar">
  <!-- <a [routerLink]="['/home']" class="logo-link"> -->
  <img src="../../../assets/images/logo.svg" alt="Logo" class="logo" />
  <div class="divider"></div>
  <a href="#" class="appTitle">Health and Well-being</a>
  <span class="spacer"></span>
  <!-- <mat-icon class="notification-icon">notifications</mat-icon> -->
  <!-- <mat-icon class="add-dependent" *ngIf="role"  style="cursor: pointer;" (click)="onIconClick()">person_add</mat-icon> -->
  <!-- <mat-icon class="profile-icon">{{userInitials}}</mat-icon> -->
  <div
    class="profile-container"
    [matMenuTriggerFor]="profileMenu"
    #menuTrigger="matMenuTrigger"
  >
    <mat-icon class="profile-icon" [matMenuTriggerFor]="profileMenu">
      {{ userInitials }}</mat-icon
    >
  </div>

  <!-- Dropdown Menu -->
  <mat-menu #profileMenu="matMenu">
    <ng-container *ngFor="let item of menus">
      <button mat-menu-item (click)="onMenuClick(item)">
        <mat-icon>{{ getMenuIcon(item) }}</mat-icon>
        <span>{{ item }}</span>
      </button>
    </ng-container>
  </mat-menu>
  <!-- 
  <mat-divider></mat-divider> -->

  <!-- <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button> -->
</mat-toolbar>
